import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { LinkContainer } from 'react-router-bootstrap'

import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

// Redux -------
import { useDispatch, useSelector } from 'react-redux'
import {
	listProducts,
	deleteProduct,
	createProduct
} from '../actions/productActions'
import { PRODUCT_CREATE_RESET } from '../constants/productConstants'

// Components -------
import Loader from '../components/Loader'
import Message from '../components/Message'
import Paginate from '../components/Paginate'

const ProductListScreen = ({ history, match }) => {
	const pageNumber = match.params.pageNumber || 1

	const dispatch = useDispatch()

	const productList = useSelector(state => state.productList)
	const { loading, error, products, pages, page } = productList

	const userLogin = useSelector(state => state.userLogin)
	const { userInfo } = userLogin

	const productDelete = useSelector(state => state.productDelete)
	const {
		loading: loadingDelete,
		error: errorDelete,
		success: successDelete
	} = productDelete

	const productCreate = useSelector(state => state.productCreate)
	const {
		loading: loadingCreate,
		error: errorCreate,
		success: successCreate,
		product: createdProduct
	} = productCreate

	useEffect(() => {
		dispatch({ type: PRODUCT_CREATE_RESET })

		if (!userInfo.isAdmin) {
			history.push('/login')
		}

		if (successCreate) {
			history.push(`/admin/product/${createdProduct._id}/edit`)
		} else {
			dispatch(listProducts('', pageNumber))
		}
	}, [
		dispatch,
		history,
		userInfo,
		successDelete,
		successCreate,
		createdProduct,
		pageNumber
	])

	const createProductHandler = () => {
		dispatch(createProduct())
	}

	const deleteHandler = id => {
		if (window.confirm('Are you sure you want to delete?')) {
			dispatch(deleteProduct(id))
		}
	}

	return (
		<>
			<Row className="align-items-center">
				<Col>
					<h1>Products</h1>
				</Col>

				<Col className="text-right">
					<Button className="my-3" onClick={createProductHandler}>
						<i className="fas fa-plus"></i> Create Product
					</Button>
				</Col>
			</Row>

			{loadingDelete && <Loader />}
			{errorDelete && <Message variant="danger">{errorDelete}</Message>}

			{loadingCreate && <Loader />}
			{errorCreate && <Message variant="danger">{errorCreate}</Message>}

			{loading ? (
				<Loader />
			) : error ? (
				<Message variant="danger">{error}</Message>
			) : (
				<>
					<Table striped bordered hover responsive className="table-sm">
						<thead>
							<tr>
								<th>ID</th>
								<th>Name</th>
								<th>Price</th>
								<th>Category</th>
								<th>Brand</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{products.map(product => (
								<tr key={product._id}>
									<td>{product._id}</td>
									<td>{product.name}</td>
									<td>${product.price}</td>
									<td>{product.category}</td>
									<td>{product.brand}</td>
									<td>
										<LinkContainer
											to={`/admin/product/${product._id}/edit`}
										>
											<Button className="btn-sm" variant="light">
												<i className="fas fa-edit"></i>
											</Button>
										</LinkContainer>

										<Button
											className="btn-sm"
											variant="danger"
											onClick={() => deleteHandler(product._id)}
										>
											<i className="fas fa-trash"></i>
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</Table>

					<Paginate pages={pages} page={page} isAdmin />
				</>
			)}
		</>
	)
}

ProductListScreen.propTypes = {
	history: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

export default ProductListScreen
